import React, { Component, Fragment } from 'react'
import { withRouteData, Head } from 'react-static'

import NewFooter from '../../../blocks/NewFooter/NewFooterV2'
import NewMenu from '../../../blocks/Menu/NewMenu'
import Picture from '../../../components/Picture'
import DemoForm from '../../../components/site/Forms/DemoForm'
import { SITE_CONSTANTS } from '../../../utils/constants'

import './Segmentos.scss'
import '../../formHero.scss'
import './SegmentosAlimentos.scss'

const ALIMENTOS_LOGO_BASE = '/images/site/landing-pages/segmentos-alimentos'

const ALIMENTOS_LOGOS = [
    { file: 'alispec.png', alt: 'Alispec' },
    { file: 'baggio.png', alt: 'Baggio Café' },
    { file: 'baldoni.png', alt: 'Baldoni' },
    { file: 'bendu.png', alt: 'Bendu' },
    { file: 'codil.png', alt: 'Codil Alimentos' },
    { file: 'ftw.png', alt: 'FTW' },
    { file: 'laganexa.png', alt: 'La Ganexa' },
    { file: 'oakberry.png', alt: 'Oakberry' },
    { file: 'sequoia.png', alt: 'Sequoia' },
    { file: 'siol.png', alt: 'Siol' },
    { file: 'tia-sonia.png', alt: 'Tia Sonia' },
    { file: 'tupy.png', alt: 'Tupy Alimentos' },
    { file: 'under-labz.png', alt: 'Under Labz' },
]

const renderAlimentosLogoSlider = () => (
    <section className="logo-slider reveal reveal--delay-1" aria-label="Empresas que confiam no Mercos">
        <ul className="logo-slider__track">
            {ALIMENTOS_LOGOS.map(logo => (
                <li className="logo-item" key={logo.file}>
                    <Picture loading="lazy" src={`${ALIMENTOS_LOGO_BASE}/${logo.file}`} alt={logo.alt} />
                </li>
            ))}
            {ALIMENTOS_LOGOS.map(logo => (
                <li className="logo-item" key={`dup-${logo.file}`} aria-hidden="true">
                    <Picture loading="lazy" src={`${ALIMENTOS_LOGO_BASE}/${logo.file}`} alt="" />
                </li>
            ))}
        </ul>
    </section>
)

const renderAlimentosTestimonials = () => (
    <section className="testimonials-section reveal" aria-labelledby="testimonials-label">
        <h4 className="testimonials-label" id="testimonials-label">
            Empresas do segmento de alimentos e bebidas<br />que confiam na Mercos
        </h4>

        <div className="testimonials-grid">
            <article className="testimonial-card">
                <p className="testimonial-card__stars" role="img" aria-label="5 de 5 estrelas"><span aria-hidden="true">★★★★★</span></p>
                <p className="testimonial-card__text open-sans">
                    &quot;A Mercos transformou o nosso processo de gestão comercial como um todo. Quando começamos em 2021, tínhamos 79 clientes. Hoje já são mais de 400. Isso só foi possível graças à tecnologia do sistema.&quot;
                </p>
                <div className="testimonial-card__reviewer">
                    <div className="testimonial-card__avatar">
                        <Picture
                            loading="lazy"
                            src="/images/site/depoimentos/marcos-rogerio-scalabrin-arte-cacau.png"
                            alt="Marcos Rogério Scalabrin"
                        />
                    </div>
                    <div>
                        <p className="testimonial-card__name">Marcos Rogério Scalabrin</p>
                        <p className="testimonial-card__company">Arte Cacau (Indústria)</p>
                    </div>
                </div>
            </article>

            <article className="testimonial-card">
                <p className="testimonial-card__stars" role="img" aria-label="5 de 5 estrelas"><span aria-hidden="true">★★★★★</span></p>
                <p className="testimonial-card__text open-sans">
                    &quot;Com todas as ferramentas integradas e o acompanhamento dos indicadores de perto, nossa distribuidora aumentou o volume de pedidos em 18% só nos últimos 6 meses.&quot;
                </p>
                <div className="testimonial-card__reviewer">
                    <div className="testimonial-card__avatar">
                        <Picture
                            loading="lazy"
                            src="/images/site/depoimentos/thais-freitas-amora-e-acerola.png"
                            alt="Thais Freitas"
                        />
                    </div>
                    <div>
                        <p className="testimonial-card__name">Thais Freitas</p>
                        <p className="testimonial-card__company">Amora e Acerola (Distribuidora)</p>
                    </div>
                </div>
            </article>

            <article className="testimonial-card">
                <p className="testimonial-card__stars" role="img" aria-label="5 de 5 estrelas"><span aria-hidden="true">★★★★★</span></p>
                <p className="testimonial-card__text open-sans">
                    &quot;Com as informações certas na palma da mão, o jogo muda: a venda deixa de ser tentativa e passa a ser estratégia. Quem quer crescer precisa tomar decisões com base em informação. É isso que o Mercos proporciona.&quot;
                </p>
                <div className="testimonial-card__reviewer">
                    <div className="testimonial-card__avatar">
                        <Picture
                            loading="lazy"
                            src="/images/site/depoimentos/bruno-barbosa-colombi.png"
                            alt="Bruno Barbosa"
                        />
                    </div>
                    <div>
                        <p className="testimonial-card__name">Bruno Barbosa</p>
                        <p className="testimonial-card__company">Barbosa &amp; Colombi Representações</p>
                    </div>
                </div>
            </article>
        </div>
    </section>
)

const heroContentMarkup = `

    <span class="overtitle open-sans reveal">Para indústrias e distribuidoras</span>


    <h1 class="hero-heading reveal reveal--delay-1" id="hero-heading">
      <strong>Sistema de vendas para alimentos e bebidas: conecte vendas, CRM e ERP em uma única operação</strong>
    </h1>


    <p class="hero-body open-sans reveal reveal--delay-2">
      Crescimento com governança comercial: o Mercos ajuda operações B2B de alimentos e bebidas a lidar com a complexidade do setor sem perder controle, produtividade e previsibilidade
    </p>


    <div class="hero-rating reveal reveal--delay-2">
      <div class="hero-stars" role="img" aria-label="Avaliação: 4,8 de 5 estrelas">
        <div class="hero-stars__icons" aria-hidden="true">
          <span>★★★★★</span>
        </div>
        <span class="hero-stars__score open-sans" aria-hidden="true">${SITE_CONSTANTS.GOOGLE_PLAY_RATING}</span>
      </div>
      <p class="hero-rating__text open-sans">
        <span id="rating-counter">12.255</span> Avaliações reais no <strong>Google Play</strong>, <strong>App Store</strong> e <strong>Google Meu Negócio</strong>
      </p>
    </div>


`

const pageMarkupBeforeTestimonials = `

<section class="segmentos-problems cards-section" aria-labelledby="cards-title">
  <div class="cards-container">

    <header class="cards-header reveal">

      <h2 class="cards-title" id="cards-title">Como empresas de alimentos e bebidas aumentam as vendas sem perder o controle comercial?</h2>
      <p class="cards-subtitle open-sans">Indústrias, distribuidoras e representantes comerciais do setor precisam lidar com múltiplos canais de venda, controle de equipe, aumento do mix de produtos e pressão por resultados. É importante contar com um sistema de vendas que ampare a operação.</p>
    </header>

    <ul class="cards-grid reveal reveal--delay-1">

      <li class="icon-card">
        <div class="icon-card__icon card--green" aria-hidden="true">
          <span class="material-symbols-outlined" aria-hidden="true">finance_mode</span>
        </div>
        <div class="icon-card__content">
          <h3 class="icon-card__title">Elimine gargalos entre vendas e faturamento</h3>
          <p class="icon-card__desc open-sans">Pedidos manuais criam gargalos que travam seu crescimento. Com o Mercos, a equipe emite pedidos por IA e acessa políticas, produtos e tabelas de preço, tudo integrado ao ERP</p>
        </div>
      </li>

      <li class="icon-card">
        <div class="icon-card__icon card--green" aria-hidden="true">
          <span class="material-symbols-outlined" aria-hidden="true">person_book</span>
        </div>
        <div class="icon-card__content">
          <h3 class="icon-card__title">Gerencie clientes e vendas em segundos</h3>
          <p class="icon-card__desc open-sans">O Mercos oferece + de 25 indicadores, relatórios e um CRM de vendas, para que gestores acompanhem o funil e a produtividade da equipe de perto, tomando decisões mais rápidas</p>
        </div>
      </li>

      <li class="icon-card">
        <div class="icon-card__icon card--green" aria-hidden="true">
          <span class="material-symbols-outlined" aria-hidden="true">sell</span>
        </div>
        <div class="icon-card__content">
          <h3 class="icon-card__title">Venda com a informação certa em mãos</h3>
          <p class="icon-card__desc open-sans">Estoque desatualizado, preços incorretos e falta de histórico geram erros. Consulte estoque, políticas, histórico de compras e preferências dos clientes no Mercos durante a negociação</p>
        </div>
      </li>

    </ul>
  </div>
</section>

<section class="cards-section reveal" aria-labelledby="solution-title">
  <div class="cards-container">

    <header class="cards-header">
      <span class="overtitle open-sans">Sistema de vendas nº1 para indústrias e distribuidoras</span>
      <h2 class="cards-title" id="solution-title">Por que o Mercos é o melhor sistema de vendas para alimentos e bebidas?</h2>
      <p class="cards-subtitle open-sans">Operações comerciais do setor precisam atender supermercados, atacarejos, distribuidores, redes de restaurantes e outros canais enquanto equilibram negociações, aumento de mix, positivação da carteira e recorrência de compras. Nós atendemos todas essas demandas com o sistema mais prático e inteligente do mercado para vendedores e gestores.</p>
    </header>

    <ul class="cards-grid reveal reveal--delay-1">

      <li class="icon-card">
        <div class="icon-card__icon card--green" aria-hidden="true">
          <span class="material-symbols-outlined" aria-hidden="true">filter_alt</span>
        </div>
        <div class="icon-card__content">
          <h3 class="icon-card__title">CRM conectado à força de vendas</h3>
          <p class="icon-card__desc open-sans">Tenha uma visibilidade completa da carteira de clientes e transforme visitas, pedidos e relacionamento com clientes em dados acionáveis para vender e garantir recompras</p>
        </div>
      </li>

      <li class="icon-card">
        <div class="icon-card__icon card--green" aria-hidden="true">
          <span class="material-symbols-outlined" aria-hidden="true">monitoring</span>
        </div>
        <div class="icon-card__content">
          <h3 class="icon-card__title">Força de vendas que atua de ponta a ponta</h3>
          <p class="icon-card__desc open-sans">Acompanhe a equipe, controle tabelas de preço, políticas comerciais, bonificações e condições de venda para reduzir erros, proteger margens e simplificar negociações com clientes</p>
        </div>
      </li>

      <li class="icon-card">
        <div class="icon-card__icon card--green" aria-hidden="true">
          <img src="https://mercos.com/images/site/icons/ai.svg" alt="" aria-hidden="true" width="24" height="24">
        </div>
        <div class="icon-card__content">
          <h3 class="icon-card__title">IA para automatizar pedidos e agilizar a operação</h3>
          <p class="icon-card__desc open-sans">Sua equipe emite pedidos por IA e você usa o WhatsApp como assistente para consultar indicadores, positivação da carteira, oportunidades de recompra e sugestões de mix</p>
        </div>
      </li>

      <li class="icon-card">
        <div class="icon-card__icon card--green" aria-hidden="true">
          <span class="material-symbols-outlined" aria-hidden="true">shopping_cart</span>
        </div>
        <div class="icon-card__content">
          <h3 class="icon-card__title">E-commerce B2B para aumentar recorrência</h3>
          <p class="icon-card__desc open-sans">Clientes como supermercados, atacarejos, distribuidores e outros fazem pedidos online a qualquer hora, de forma independente ou com apoio do representante comercial</p>
        </div>
      </li>

      <li class="icon-card">
        <div class="icon-card__icon card--green" aria-hidden="true">
          <span class="material-symbols-outlined" aria-hidden="true">credit_card</span>
        </div>
        <div class="icon-card__content">
          <h3 class="icon-card__title">Mercos Pay para facilitar o pagamento dos pedidos</h3>
          <p class="icon-card__desc open-sans">Permita que os clientes paguem diretamente no checkout do e-commerce B2B ou por links enviados pelos vendedores, acelerando o fechamento de pedidos</p>
        </div>
      </li>

      <li class="icon-card">
        <div class="icon-card__icon card--green" aria-hidden="true">
          <span class="material-symbols-outlined" aria-hidden="true">account_tree</span>
        </div>
        <div class="icon-card__content">
          <h3 class="icon-card__title">Integração com qualquer ERP ou sistema desejado</h3>
          <p class="icon-card__desc open-sans">A API aberta do Mercos permite integrar a operação aos sistemas que você já usa, conectando pedidos, clientes, produtos e processos em um único fluxo de trabalho</p>
        </div>
      </li>

    </ul>
  </div>
</section>

  <section class="stats-card reveal" aria-labelledby="stats-heading">


    <div class="stats-card__decoration reveal reveal--delay-3" aria-hidden="true">
      <svg viewBox="0 0 1200 360" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
        <defs>
          <linearGradient id="curveGrad1" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#8B5CF6"/>
            <stop offset="100%" stop-color="#22C55E"/>
          </linearGradient>
          <linearGradient id="curveGrad2" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#A78BFA" stop-opacity="0.5"/>
            <stop offset="100%" stop-color="#86EFAC" stop-opacity="0.5"/>
          </linearGradient>
          <linearGradient id="fillGrad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#22C55E" stop-opacity="0"/>
            <stop offset="100%" stop-color="#22C55E" stop-opacity="0.09"/>
          </linearGradient>
          <clipPath id="revealClip">
            <rect id="clipRect" x="0" y="-10" width="0" height="380"/>
          </clipPath>
        </defs>

        <g clip-path="url(#revealClip)">

          <path
            d="M0 360 C900 360 1050 60 1200 0 L1200 360 Z"
            fill="url(#fillGrad)"
          />


          <path
            d="M0 360 C900 360 1050 60 1200 0"
            stroke="url(#curveGrad1)"
            stroke-width="2.5"
            fill="none"
          />
        </g>
      </svg>
    </div>


    <h3 class="stats-card__headline" id="stats-heading">O sistema para alimentos e bebidas que cresce com você.</h3>
    <h4 class="stats-card__subheadline">O Mercos processa bilhões de reais em pedidos com sincronização em tempo real.</h4>


    <ul class="stats-grid">
      <li class="stat-item">
        <strong class="stat-number">18.000.000</strong>
        <p class="stat-label open-sans">de pedidos por ano na plataforma</p>
      </li>

      <li class="stat-item">
        <strong class="stat-number">R$ 100 bilhões</strong>
        <p class="stat-label open-sans">anuais movimentados através do Mercos</p>
      </li>

      <li class="stat-item">
        <strong class="stat-number"><span class="prefix">+ </span>250</strong>
        <p class="stat-label open-sans">ERPs integrados</p>
      </li>

      <li class="stat-item">
        <strong class="stat-number">56.000</strong>
        <p class="stat-label open-sans">usuários ativos</p>
      </li>

      <li class="stat-item">
        <strong class="stat-number"><span class="prefix">+ </span>9.000</strong>
        <p class="stat-label open-sans">clientes</p>
      </li>
    </ul>

  </section>

`

const pageMarkupAfterTestimonials = `

  <section class="segmentos-faq faq-section reveal" aria-labelledby="faq-title">
    <div class="faq-content">

      <div class="faq-header">
        <div class="faq-header__icon-wrap">
          <img src="/images/site/landing-pages/segmentos/help.svg"
            alt="">
        </div>
        <div class="faq-header__text-col">
          <h2 class="faq-header__title" id="faq-title">Perguntas frequentes</h2>
          <p class="faq-header__subtitle open-sans">
            Saiba mais sobre o sistema de vendas para alimentos e bebidas da Mercos e confira as principais
            dúvidas que podem surgir.
          </p>
        </div>
      </div>

      <ul class="faq-accordion">


        <li class="faq-item faq-item--open">
          <button
            class="faq-item__btn"
            aria-expanded="true"
            aria-controls="faq-answer-1">
            <h3 class="faq-item__question">
              Como acabar com os pedidos manuais que chegam por WhatsApp em empresas B2B de alimentos e bebidas?
            </h3>
            <img class="faq-item__arrow"
              src="/images/site/landing-pages/segmentos/keyboard-arrow-down.svg"
              alt=""
              aria-hidden="true">
          </button>
          <div class="faq-item__answer" id="faq-answer-1">
            <div class="faq-item__answer-inner open-sans">
              <p>Com Mercos IA, é possível transformar qualquer pedido que chega por WhatsApp, por áudio, foto, texto ou planilha em um pedido pronto para faturamento no sistema em segundos.</p>
              <p>Além disso, o Mercos centraliza pedidos, vendas online pelo e-commerce B2B, tabelas de preços, estoque e histórico de clientes em um único aplicativo. Dessa forma, vendedores deixam de depender de anotações manuais, reduzindo erros e acelerando o faturamento.</p>
            </div>
          </div>
        </li>


        <li class="faq-item">
          <button
            class="faq-item__btn"
            aria-expanded="false"
            aria-controls="faq-answer-2">
            <h3 class="faq-item__question">
              Como reduzir erros de estoque, preços, descontos e pedidos em empresas B2B de alimentos e bebidas?
            </h3>
            <img class="faq-item__arrow"
              src="/images/site/landing-pages/segmentos/keyboard-arrow-down.svg"
              alt=""
              aria-hidden="true">
          </button>
          <div class="faq-item__answer" id="faq-answer-2">
            <div class="faq-item__answer-inner open-sans">
              <p>O sistema centraliza políticas comerciais, tabelas de preço, campanhas, regras de desconto e exibe informações atualizadas de estoque diretamente para os representantes durante a negociação.</p>
              <p>Além disso, com o recurso Saldo Flex, vendedores podem conceder descontos ou negociar condições dentro dos parâmetros definidos pela empresa, reduzindo aprovações, acelerando as vendas e mantendo o controle da margem.</p>
            </div>
          </div>
        </li>


        <li class="faq-item">
          <button
            class="faq-item__btn"
            aria-expanded="false"
            aria-controls="faq-answer-3">
            <h3 class="faq-item__question">
              Como acompanhar o trabalho dos representantes externos em uma empresa de alimentos e bebidas B2B?
            </h3>
            <img class="faq-item__arrow"
              src="/images/site/landing-pages/segmentos/keyboard-arrow-down.svg"
              alt=""
              aria-hidden="true">
          </button>
          <div class="faq-item__answer" id="faq-answer-3">
            <div class="faq-item__answer-inner open-sans">
              <p>O Mercos oferece indicadores de desempenho, histórico de visitas, acompanhamento do funil comercial por meio do CRM de Vendas, relatórios de vendas e análise de positivação.</p>
              <p>Dessa forma, gestores conseguem entender o que está acontecendo na operação em tempo real enquanto a equipe está em campo. Além disso, conseguem identificar clientes sem compras recentes, acompanhar a positivação da carteira e entender quais regiões ou vendedores possuem maior potencial de crescimento.</p>
            </div>
          </div>
        </li>


        <li class="faq-item">
          <button
            class="faq-item__btn"
            aria-expanded="false"
            aria-controls="faq-answer-4">
            <h3 class="faq-item__question">
              O Mercos é um CRM ou um sistema de força de vendas para indústrias e distribuidoras de alimentos e bebidas?
            </h3>
            <img class="faq-item__arrow"
              src="/images/site/landing-pages/segmentos/keyboard-arrow-down.svg"
              alt=""
              aria-hidden="true">
          </button>
          <div class="faq-item__answer" id="faq-answer-4">
            <div class="faq-item__answer-inner open-sans">
              <p>O Mercos combina CRM e força de vendas em uma única plataforma. Além de organizar relacionamentos e atividades comerciais, ele acompanha pedidos, visitas, negociações e resultados da carteira de clientes.</p>
              <p>Além disso, oferece e-commerce B2B para vendas online, Mercos Pay para recebimento de pagamentos e recursos de Inteligência Artificial para agilizar e facilitar a operação comercial de indústrias e distribuidoras que atendem clientes B2B. O sistema foi desenvolvido para operações com equipes externas e vendas recorrentes.</p>
            </div>
          </div>
        </li>


        <li class="faq-item">
          <button
            class="faq-item__btn"
            aria-expanded="false"
            aria-controls="faq-answer-5">
            <h3 class="faq-item__question">
              Qual o melhor sistema de vendas para empresas B2B de alimentos e bebidas?
            </h3>
            <img class="faq-item__arrow"
              src="/images/site/landing-pages/segmentos/keyboard-arrow-down.svg"
              alt=""
              aria-hidden="true">
          </button>
          <div class="faq-item__answer" id="faq-answer-5">
            <div class="faq-item__answer-inner open-sans">
              <p>O melhor sistema de vendas para empresas B2B de alimentos e bebidas é aquele que centraliza pedidos, gestão comercial, CRM, estoque, e-commerce B2B, pagamentos e integração com ERP em uma única plataforma.</p>
              <p>O Mercos reúne todos esses recursos, além de Inteligência Artificial para automatizar pedidos e apoiar a tomada de decisão comercial. Assim, vendedores e representantes trabalham com mais produtividade, controle e visibilidade da operação.</p>
            </div>
          </div>
        </li>


        <li class="faq-item">
          <button
            class="faq-item__btn"
            aria-expanded="false"
            aria-controls="faq-answer-6">
            <h3 class="faq-item__question">
              Como integrar pedidos, vendedores e ERP em uma empresa de alimentos e bebidas?
            </h3>
            <img class="faq-item__arrow"
              src="/images/site/landing-pages/segmentos/keyboard-arrow-down.svg"
              alt=""
              aria-hidden="true">
          </button>
          <div class="faq-item__answer" id="faq-answer-6">
            <div class="faq-item__answer-inner open-sans">
              <p>O Mercos integra a operação comercial a qualquer ERP, conectando pedidos, clientes, produtos, tabelas de preço, estoque e informações financeiras em uma única plataforma.</p>
              <p>Assim, representantes trabalham com dados atualizados durante a negociação, enquanto os pedidos são enviados automaticamente para o ERP, reduzindo retrabalho, eliminando digitação manual e acelerando o processo de faturamento.</p>
              <p>A empresa ganha mais controle sobre a operação comercial e evita erros causados pela falta de integração entre vendas e gestão.</p>
            </div>
          </div>
        </li>

      </ul>
    </div>
  </section>

<section class="cta-banner reveal" aria-label="Agendar demonstração">
  <div class="cta-banner__card">
    <h4 class="cta-banner__text open-sans">A demo costuma durar 30 a 45 minutos e é conduzida por um especialista em indústrias e distribuidoras.</h4>
    <button type="button" class="cta-banner__btn js-segmentos-open-demo">
      Solicitar demonstração
    </button>
  </div>
  <div class="cta-banner__footer reveal reveal--delay-1">
    <span class="cta-banner__dot" aria-hidden="true"></span>
    <span class="cta-banner__label open-sans">Especialista dedicado</span>
    <span class="cta-banner__dot" aria-hidden="true"></span>
    <span class="cta-banner__label open-sans">Demonstração personalizada</span>
    <span class="cta-banner__dot" aria-hidden="true"></span>
    <span class="cta-banner__label open-sans">Resposta em até 5h úteis</span>
  </div>
</section>

`

class SegmentosAlimentos extends Component {
    constructor(props) {
        super(props)
        this.state = {
            menuVisible: true,
        }
        this.scrollDirection = {
            lastScrollTop: 0,
            isScrollingDown: false,
        }
    }

    handleScroll = () => {
        if (document.body.classList.contains('mobile-menu-is-open')) return

        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop
        if (Math.abs(currentScrollTop - this.scrollDirection.lastScrollTop) > 5) {
            this.scrollDirection.isScrollingDown = currentScrollTop > this.scrollDirection.lastScrollTop
            this.scrollDirection.lastScrollTop = currentScrollTop
            this.setState({ menuVisible: currentScrollTop <= 100 || !this.scrollDirection.isScrollingDown })
        }
    }

    openDemoModal = e => {
        if (e) e.preventDefault()
        if (this.demoFormRef) this.demoFormRef.openDemoModal(e || { preventDefault() {} })
    }

    componentDidMount() {
        if (typeof document !== 'undefined') {
            document.documentElement.classList.add('lp-segmentos-html')
            document.body.classList.add('lp-segmentos-body', 'lp-segmentos-body--alimentos')
        }

        this.faqCleanups = Array.prototype.map.call(document.querySelectorAll('.lp-segmentos .faq-item__btn'), btn => {
            const toggleFaq = () => {
                const item = btn.closest('.faq-item')
                const isOpen = item.classList.contains('faq-item--open')

                Array.prototype.forEach.call(document.querySelectorAll('.lp-segmentos .faq-item'), faqItem => {
                    faqItem.classList.remove('faq-item--open')
                    faqItem.querySelector('.faq-item__btn').setAttribute('aria-expanded', 'false')
                })

                if (!isOpen) {
                    item.classList.add('faq-item--open')
                    btn.setAttribute('aria-expanded', 'true')
                }
            }
            btn.addEventListener('click', toggleFaq)
            return () => btn.removeEventListener('click', toggleFaq)
        })

        this.ctaCleanups = Array.prototype.map.call(document.querySelectorAll('.lp-segmentos .js-segmentos-open-demo'), btn => {
            btn.addEventListener('click', this.openDemoModal)
            return () => btn.removeEventListener('click', this.openDemoModal)
        })

        globalThis.optimizeOpenPopup = this.openDemoModal

        window.addEventListener('scroll', this.handleScroll, { passive: true })

        if ('IntersectionObserver' in window) {
            this.revealObserver = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) entry.target.classList.add('is-visible')
                })
            }, { threshold: 0.12 })
            Array.prototype.forEach.call(document.querySelectorAll('.lp-segmentos .reveal'), el => this.revealObserver.observe(el))
        } else {
            Array.prototype.forEach.call(document.querySelectorAll('.lp-segmentos .reveal'), el => el.classList.add('is-visible'))
        }
    }

    componentWillUnmount() {
        if (this.faqCleanups) this.faqCleanups.forEach(cleanup => cleanup())
        if (this.ctaCleanups) this.ctaCleanups.forEach(cleanup => cleanup())
        if (this.revealObserver) this.revealObserver.disconnect()
        if (globalThis.optimizeOpenPopup === this.openDemoModal) delete globalThis.optimizeOpenPopup
        window.removeEventListener('scroll', this.handleScroll)
        if (typeof document !== 'undefined') {
            document.documentElement.classList.remove('lp-segmentos-html')
            document.body.classList.remove('lp-segmentos-body', 'lp-segmentos-body--alimentos')
        }
    }

    render() {
        const { headData } = this.props
        const { menuVisible } = this.state

        return (
            <Fragment>
                <NewMenu transparentOnTop pixelsToShowMenuWhite={50} mutableMenu hideOnScroll menuVisible={menuVisible} />
                {headData && (
                    <Head>
                        <title>{headData.pageTitle}</title>
                        <meta property="og:title" content={headData.pageTitle} />
                        <meta name="twitter:title" content={headData.pageTitle} />
                        <meta name="description" content={headData.pageDescription} />
                        <meta property="og:description" content={headData.pageDescription} />
                        <meta name="twitter:description" content={headData.pageDescription} />
                        <meta property="og:image" content={headData.ogImage} />
                        <meta name="twitter:image" content={headData.ogImage} />
                        <meta property="og:url" content={headData.ogUrl} />
                        <link rel="canonical" href={headData.canonicalUrl || headData.ogUrl} />
                        <link rel="preconnect" href="https://fonts.googleapis.com" />
                        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
                        <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Open+Sans:wght@400;600;700&display=swap" rel="stylesheet" />
                        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
                        <script type="application/ld+json">
                          {`{
                            "@context": "https://schema.org",
                            "@type": "FAQPage",
                            "mainEntity": [
                              {
                                "@type": "Question",
                                "name": "Como acabar com os pedidos manuais que chegam por WhatsApp em empresas B2B de alimentos e bebidas?",
                                "acceptedAnswer": {
                                  "@type": "Answer",
                                  "text": "Com Mercos IA, é possível transformar qualquer pedido que chega por WhatsApp, por áudio, foto, texto ou planilha em um pedido pronto para faturamento no sistema em segundos.\\n\\nAlém disso, o Mercos centraliza pedidos, vendas online pelo e-commerce B2B, tabelas de preços, estoque e histórico de clientes em um único aplicativo. Dessa forma, vendedores deixam de depender de anotações manuais, reduzindo erros e acelerando o faturamento."
                                }
                              },
                              {
                                "@type": "Question",
                                "name": "Como reduzir erros de estoque, preços, descontos e pedidos em empresas B2B de alimentos e bebidas?",
                                "acceptedAnswer": {
                                  "@type": "Answer",
                                  "text": "O sistema centraliza políticas comerciais, tabelas de preço, campanhas, regras de desconto e exibe informações atualizadas de estoque diretamente para os representantes durante a negociação.\\n\\nAlém disso, com o recurso Saldo Flex, vendedores podem conceder descontos ou negociar condições dentro dos parâmetros definidos pela empresa, reduzindo aprovações, acelerando as vendas e mantendo o controle da margem."
                                }
                              },
                              {
                                "@type": "Question",
                                "name": "Como acompanhar o trabalho dos representantes externos em uma empresa de alimentos e bebidas B2B?",
                                "acceptedAnswer": {
                                  "@type": "Answer",
                                  "text": "O Mercos oferece indicadores de desempenho, histórico de visitas, acompanhamento do funil comercial por meio do CRM de Vendas, relatórios de vendas e análise de positivação.\\n\\nDessa forma, gestores conseguem entender o que está acontecendo na operação em tempo real enquanto a equipe está em campo. Além disso, conseguem identificar clientes sem compras recentes, acompanhar a positivação da carteira e entender quais regiões ou vendedores possuem maior potencial de crescimento."
                                }
                              },
                              {
                                "@type": "Question",
                                "name": "O Mercos é um CRM ou um sistema de força de vendas para indústrias e distribuidoras de alimentos e bebidas?",
                                "acceptedAnswer": {
                                  "@type": "Answer",
                                  "text": "O Mercos combina CRM e força de vendas em uma única plataforma. Além de organizar relacionamentos e atividades comerciais, ele acompanha pedidos, visitas, negociações e resultados da carteira de clientes.\\n\\nAlém disso, oferece e-commerce B2B para vendas online, Mercos Pay para recebimento de pagamentos e recursos de Inteligência Artificial para agilizar e facilitar a operação comercial de indústrias e distribuidoras que atendem clientes B2B. O sistema foi desenvolvido para operações com equipes externas e vendas recorrentes."
                                }
                              },
                              {
                                "@type": "Question",
                                "name": "Qual o melhor sistema de vendas para empresas B2B de alimentos e bebidas?",
                                "acceptedAnswer": {
                                  "@type": "Answer",
                                  "text": "O melhor sistema de vendas para empresas B2B de alimentos e bebidas é aquele que centraliza pedidos, gestão comercial, CRM, estoque, e-commerce B2B, pagamentos e integração com ERP em uma única plataforma.\\n\\nO Mercos reúne todos esses recursos, além de Inteligência Artificial para automatizar pedidos e apoiar a tomada de decisão comercial. Assim, vendedores e representantes trabalham com mais produtividade, controle e visibilidade da operação."
                                }
                              },
                              {
                                "@type": "Question",
                                "name": "Como integrar pedidos, vendedores e ERP em uma empresa de alimentos e bebidas?",
                                "acceptedAnswer": {
                                  "@type": "Answer",
                                  "text": "O Mercos integra a operação comercial a qualquer ERP, conectando pedidos, clientes, produtos, tabelas de preço, estoque e informações financeiras em uma única plataforma.\\n\\nAssim, representantes trabalham com dados atualizados durante a negociação, enquanto os pedidos são enviados automaticamente para o ERP, reduzindo retrabalho, eliminando digitação manual e acelerando o processo de faturamento.\\n\\nA empresa ganha mais controle sobre a operação comercial e evita erros causados pela falta de integração entre vendas e gestão."
                                }
                              }
                            ]
                          }`}
                        </script>
                        <script type="application/ld+json">
                          {`{
                            "@context": "https://schema.org",
                            "@type": "WebPage",
                            "name": "Sistema de vendas para alimentos e bebidas",
                            "description": "Sistema para indústrias e distribuidoras de alimentos e bebidas com IA, CRM, força de vendas, e-commerce B2B, pedidos integrados ao ERP e gestão comercial completa.",
                            "url": "https://mercos.com/lp/sistema-de-vendas-para-alimentos-e-bebidas/",
                            "inLanguage": "pt-BR",
                            "isPartOf": {
                              "@type": "WebSite",
                              "name": "Mercos",
                              "url": "https://mercos.com"
                            },
                            "about": {
                              "@type": "Thing",
                              "name": "Sistema de vendas B2B para alimentos e bebidas"
                            },
                            "publisher": {
                              "@type": "Organization",
                              "name": "Mercos",
                              "url": "https://mercos.com"
                            }
                          }`}
                        </script>
                        <script type="application/ld+json">
                          {`{
                            "@context": "https://schema.org",
                            "@type": "SoftwareApplication",
                            "name": "Mercos",
                            "url": "https://mercos.com",
                            "applicationCategory": "BusinessApplication",
                            "description": "Plataforma de vendas B2B para alimentos e bebidas com CRM, Força de Vendas, IA, e-commerce B2B e solução de pagamentos integrada.",
                            "featureList": [
                              "CRM para gestão de clientes B2B",
                              "Força de Vendas para pedidos em campo",
                              "IA para automação de pedidos",
                              "E-commerce B2B para vendas digitais",
                              "Mercos Pay para pagamentos e cobranças"
                            ]
                          }`}
                        </script>
                    </Head>
                )}
                <div className="lp-segmentos lp-segmentos--alimentos">
                    <main>
                        <section className="hero form-hero-v1 form-hero-scoped" aria-labelledby="hero-heading">
                            <div className="form-hero-v1__main">
                                <div className="hero-content form-hero-v1__content" dangerouslySetInnerHTML={{ __html: heroContentMarkup }} />
                                <div className="form-hero-v1__form reveal reveal--delay-2">
                                    <DemoForm
                                        ref={ref => { this.demoFormRef = ref }}
                                        showForm
                                        inline
                                        minimalStyle
                                        formHeroStyle
                                        title="Fale com um especialista e veja o Mercos na prática"
                                        submitButtonText="Solicitar Demonstração"
                                    />
                                </div>
                            </div>
                        </section>
                        {renderAlimentosLogoSlider()}
                        <div dangerouslySetInnerHTML={{ __html: pageMarkupBeforeTestimonials }} />
                        {renderAlimentosTestimonials()}
                        <div dangerouslySetInnerHTML={{ __html: pageMarkupAfterTestimonials }} />
                    </main>
                </div>

                <NewFooter />
            </Fragment>
        )
    }
}

export default withRouteData(props => <SegmentosAlimentos {...props} />)



// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/site/landing-pages/SegmentosAlimentos.jsx